import React from 'react'
import { pick } from 'lodash-es'
import { Pagination } from '@ow/comps'
import { useTbViewStore } from '@vt/hooks'

const PaginationContainer = function () {
  const { pageSize, setPage, pageNum, total } = useTbViewStore((state) =>
    pick(state, ['pageSize', 'setPage', 'pageNum', 'total'])
  )

  return (
    <Pagination
      defaultPage={pageNum + 1}
      pageSize={pageSize}
      total={total}
      pageSizeOptions={[10, 20, 50, 100]}
      forceEllipses
      onPageNumChange={(num) => {
        setPage(pageSize, num - 1)
      }}
      onPageSizeChange={(size) => {
        setPage(size, 0)
      }}
    />
  )
}

export default PaginationContainer
